import React, {createContext, useContext, useState} from "react";

interface AppColors {
    primary: string;
    alternatePrimary: string;
    primaryLight: string;
    primaryDark: string;
    grey: string;
    white: string;
    greyLight: string;
    success: string;
    error: string;
    warning: string;
}

interface ColorContextType {
    colors: AppColors;
    setColors: React.Dispatch<React.SetStateAction<AppColors>>;
}

export const ColorContext = createContext<ColorContextType | null>(null);

export const ColorContextProvider = ({ children }: { children: React.ReactNode }) => {
    const [colors, setColors] = useState<AppColors>({
        primary: `#8C52FF`,
        alternatePrimary: `#1C0054`,
        primaryLight: `#F1E9FF`,
        primaryDark: `#282c34`,
        grey: '#9A96A3',
        white: '#fff',
        greyLight: `#F7F5FA`,
        success: `#4DBC3B`,
        error: `#FF3633`,
        warning: `#FFA800`
    });

    const value = {colors, setColors};

    return (
        <ColorContext.Provider value={value}> {children} </ColorContext.Provider>
    );
};

export default ColorContext;

export const useColor = (): ColorContextType => {
    const ctx = useContext(ColorContext);
    if (!ctx) throw new Error('useColor must be used within ColorContextProvider');
    return ctx;
};
